var path = 'modules/dcb-eaccount.pages.eadashboard/components/payments.tpl.html';
var html = "<div ng-controller=\"DashboardGetDasStatisticController as controller\" ng-init=\"controller.ownInit(cadid)\">\n  <div class=\"portlet-body portlet-mini\" ng-class=\"{loading : controller[controller.contractId].loading}\">\n    <dc-spinner></dc-spinner>\n    <h3 class=\"plain-heading\">\n      <small data-i18n=\"modules.dashboard.credits\"></small>\n      <br>\n      {{controller[controller.contractId].credits | money}}\n    </h3>\n  </div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./~/ngtemplate-loader?relativeTo=/src/ui/modules/eaDashboard/components&prefix=modules/dcb-eaccount.pages.eadashboard/components!./~/raw-loader!./src/ui/modules/eaDashboard/components/payments.tpl.html
// module id = 909
// module chunks = 12